import React from "react";
import MUIDataTable from "mui-datatables";

import {
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

import { THEME_COLOR } from "./../../config/config";

const theme = createMuiTheme({
  shadows: Array(5).fill("none"),
  root: {
    "& MuiInputLabel-outlined": {
      zIndex: 0,
    },
    "& MuiTableHead": {
      zIndex: 0,
    },
  },
  overrides: {
    MUIDataTableHeadCell: {
      root: {
        zIndex: 0,
      },
      fixedHeader: {
        zIndex: 0,
      },
    },
    MuiTableFooter: {
      root: {
        background: '#f0f2f4',
      },
    },
  },
  MuiFormLabel: {
    zIndex: 0,
  },
  MuiTableHead: { zIndex: 0 },
  palette: {
    primary: {
      main: THEME_COLOR, //your color
    },
  },
});

export default function DataTableExtended(props) {
  let responsive = "standard";
  let tableBodyHeight = "100%";
  let tableBodyMinHeight = "200px";
  const options = {
    filter: true,
    responsive,
    tableBodyHeight,
    tableBodyMinHeight,
    selectableRows: false,
    rowsPerPage: 50,
    rowsPerPageOptions: [25, 50, 100],
    jumpToPage: true,
    rowHover: true,
  };

  return (
    <ThemeProvider theme={theme}>
      <div>
        <MUIDataTable
          title={props.title}
          data={props.tableData}
          columns={props.columns}
          options={options}
        />
      </div>
    </ThemeProvider>
  );
}
